import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import orgConfig from 'org/configs/org.config';

const { earnType, instoreLabel } = orgConfig;

function InstoreOfferModalTitle({ offer, shouldShowRate }) {
  const { rclonMerchantName, displayRate, currency } = offer;
  const earnData = shouldShowRate ? `${displayRate} ${currency}` : earnType;

  return (
    <SectionTitle
      id="mn_dialogTitle"
      title={
        <>
          Earn {earnData} when you shop <span className="mn_noWrap">{instoreLabel}</span>{' '}
          <span className="mn_minor">at</span> {rclonMerchantName}<span className="mn_dot">.</span>
        </>
      }
    />
  );
}

export default (props) => <ComponentErrorBoundary><InstoreOfferModalTitle {...props} /></ComponentErrorBoundary>;
